

export default {
  name: 'SghPopupNewsletter',
  props: {
    srcDesktop: {
      type: String,
      default: '',
    },
    srcMobile: {
      type: String,
      default: '',
    },
    altText: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      open: false,
    }
  },
  computed: {
    isMobile() {
      return this.$mq === 'tablet' || this.$mq === 'tabletLandscape'
    },
  },
  mounted() {
    window.openNewsletterPopup = () => this.toggleNewsletterPopup(true)
  },
  methods: {
    toggleNewsletterPopup(isOpen) {
      document.querySelector('body').classList.toggle('scroll-hidden', isOpen)
      this.open = isOpen
    },
  },
}
